import SidebarLayout from '../../components/SidebarLayout';
import TreatmentsForm from '../../components/sections/MTSS/TreatmentsForm';
import AccessWrapper from '../../components/AccessWrapper';
import AuthContext from '../../context/AuthContext';
import React, { useEffect, useContext } from 'react';

export default function Watchlist() {
  const { postPageView, user, baseUrl } = useContext(AuthContext);

  useEffect(() => {
    postPageView(baseUrl, user.name, user.role, 'form/add-treatment');
  }, []);
  return (
    <AccessWrapper allowedGroups={['mtss_admin']}>
      <div>
        <SidebarLayout
          propComponents={<TreatmentsForm />}
          heading={'Add Treatment'}
        />
      </div>
    </AccessWrapper>
  );
}
